import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import classNames from "classnames";
import classes from "./index.module.scss";
import CloseButton from "../CloseButton";
import { Slide } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide  direction="up" ref={ref} {...props} />;
});

const Modal = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "sm",
  fullWidth = true,
  className,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      className={classNames(classes.modal, className)}
      TransitionComponent={Transition}
      keepMounted
      PaperProps={{
        className: classes.paper,
      }}
    >
      {title && (
        <DialogTitle className={classes.title}>
          <Typography
            variant="h6"
            component="div"
            className={classNames(classes.titleText,'text-amber-950')}
          >
            {title}
          </Typography>
          <CloseButton onClose={onClose} />
        </DialogTitle>
      )}
      <DialogContent className={classes.content}>{children}</DialogContent>
      {actions && (
        <DialogActions className={classes.actions}>{actions}</DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
